<template>
  <div class="success">
    <common-head title="预约号源" go="/home" />
    <div class="top-notice">
      <img src="@/assets/imgs/yuyuechenggong.png" v-if="reserve">
      <div class="text-box">
        <h3>{{ reserve ? '预约成功！' : '已取消' }}</h3>
        <span>{{ reserve ? '请接种日当天打开APP签到登记' : '疫苗预约已取消，如有需要请重新预约' }}</span>
      </div>
    </div>
    <div class="main">
      <div class="my-card">
        <van-cell title="受种者" :value="params.profileName" />
        <van-cell title="预约疫苗" :value="vacc.vaccineName" />
      </div>
      <div class="my-card">
        <van-cell title="预约门诊">
          <template #right-icon>
            <div class="right">
              <span>{{ params.povName }}</span>
              <van-tag plain type="primary" v-if="params.povType == '4'">24H</van-tag>
            </div>
          </template>
        </van-cell>
        <van-cell title="预约地址" :value="params.address" />
        <van-cell title="门诊时间" :value="params.time" />
        <van-cell title="门诊类型" value="互联网门诊" />
        <van-cell title="签到时间" :value="date" />
        <div class="notice">
          <p>
            <span>互联网门诊预约须知</span>
            (预约即代表同意以下规则)
          </p>
          <ul>
            <li>1. 医师服务费由医院设定本平台不收取任何额外费用</li>
            <li>2. 停诊将短信通知，请保持手机畅通</li>
            <li>3. 实名制预约，受种者信息不符将无法接种</li>
            <li>4. 门诊为网上就诊，届时医师将拨打患者网络电话，如无法在预约时间内签到视为<span>爽约</span></li>
          </ul>
        </div>
      </div>
      <div class="btn" v-if="reserve">
        <van-button round @click="action">取消预约</van-button>
        <van-button round type="info" @click="enterHome">返回首页</van-button>
      </div>
      <div class="re" v-else>
        <van-button type="info" round block @click="enterHome">重新预约</van-button>
      </div>
    </div>
    <!-- 弹窗 -->
    <van-action-sheet v-model="show" title="取消预约提醒">
      <div class="content">
        <div>根据门诊疫苗预约规定：</div>
        <ul>
          <li>第一次取消预约，用户当天不可进行再次预约；</li>
          <li>第二次取消预约，用户本周不可进行再次预约；</li>
          <li>第三次取消预约，用户本月不可进行再次预约。</li>
        </ul>
        <p>请确认，您是否继续取消本次疫苗预约？</p>
        <div class="btn">
          <van-button round @click="cancel">否</van-button>
          <van-button round type="info" @click="confirm">是</van-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import { subscribeDetail } from 'api/appointment'
import { cancleApplay } from 'api/user'

export default {
  components: {
    CommonHead
  },
  computed: {
    params() {
      return this.$store.state.params
    },
    vacc() {
      return this.$store.state.params.addAppReservationDetailREQ[0]
    },
    date() {
      return this.$route.query.reservationDate + ' ' + this.$route.query.reservationTime
    }
  },
  data() {
    return {
      reserve: true,
      show: false,
      detailId: ''
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    // 获取预约详情
    getDetail() {
      const params = {
        profileId: this.$store.state.params.profileId
      }
      subscribeDetail(params).then(res => {
        this.detailId = res.data[0].detailId
      })
    },
    // 确认取消
    confirm() {
      this.show = false
      cancleApplay({id: this.detailId}).then(res => {
        if (res.code != 0) {
          this.$toast(res.message)
        } else {
          this.$toast('取消成功')
          this.reserve = false
        }
      })
    },
    cancel() {
      this.show = false
    },
    action() {
      this.show = true
    },
    enterHome() {
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="less" scoped>
.success {
  .top-notice {
    height: 123px;
    background: url(../../assets/imgs/top-notice.jpg) no-repeat center/100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(-0.3px);
    img {
      width: 64px;
      height: 47px;
      margin-right: 10px;
    }
    .text-box {
      color: #fff;
      h3 {
        font-size: 18px;
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
  .main {
    padding: 13px;
    .my-card {
      padding: 0;
      margin-bottom: 13px;
    }
    .notice {
      font-size: 12px;
      color: #999;
      padding: 16px;
      span {
        color: var(--orange);
      }
      p {
        margin-bottom: 12px;
      }
    }
    .btn {
      display: flex;
      justify-content: space-between;
      .van-button {
        width: 49%;
      }
    }
    .re {
      padding: 20px 0;
    }
  }
}
.content {
  padding: 13px;
  color: var(--grey);
  line-height: 22px;
  ul {
    margin-bottom: 30px;
  }
  .btn {
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    .van-button {
      width: 49%;
    }
  }
}
.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 50%;
  .van-tag {
    margin-left: 5px;
  }
}
.van-cell__title span {
  color: #666;
}
.van-cell__value span {
  color: #333;
}
</style>